import useSWR from 'swr'
import API from '../../../utils/api'
import { EXCHANGESETTINGS } from '../../constants/APIKEYS'

let KEY = EXCHANGESETTINGS

let swrData: any = null

let lastcall: any = null

export function useExchangeList(isAll = false) {
	KEY = `${EXCHANGESETTINGS}?id=0&isall=1`

	const { data, mutate } = useSWR<any>(
		KEY,
		async () => {
			if(swrData){
				if(lastcall){
					const diff = new Date().getTime() - new Date(lastcall).getTime()
					if(diff < 1000 * 60 * 60){
						return swrData
					}
				}else{
					return swrData
				}
			}


			const response = await API.get(KEY, '', {}, false)
			swrData = response.result
			lastcall = new Date().getTime()

			return swrData
		},
		{ revalidateOnFocus: false, dedupingInterval: 1000 * 60 * 60, refreshWhenHidden: false }
	)

	//같은 codename 은 하나만 존재해야함
	const data2 = data?.filter((item: any, index: number, self: any) => {
		return index === self.findIndex((t: any) => t.codename === item.codename)
	})

	return {
		data,
		data2,
		mutate: (value: any) => {
			if (value !== undefined) swrData = value
			return mutate()
		},
	}
}
